type ImportEntry = {
  defaultImport: string | null;
  namespaceImport: string | null;
  namedImports: Set<string>;
};

type ImportMap = Record<string, ImportEntry>;

export function mergeImportMaps(...maps: ImportMap[]): ImportMap {
  const result: ImportMap = {};

  for (const map of maps) {
    for (const source of Object.keys(map)) {
      const incoming = map[source];

      if (!result[source]) {
        // 深拷贝，避免 Set 共享引用
        result[source] = {
          defaultImport: incoming.defaultImport,
          namespaceImport: incoming.namespaceImport,
          namedImports: new Set(incoming.namedImports),
        };
        continue;
      }

      const existing = result[source];

      // 1️⃣ 合并 named imports（并集）
      incoming.namedImports.forEach((name) => {
        existing.namedImports.add(name);
      });

      // 2️⃣ 合并 default import
      if (
        existing.defaultImport &&
        incoming.defaultImport &&
        existing.defaultImport !== incoming.defaultImport
      ) {
        throw new Error(
          `Conflicting default imports from "${source}": ` +
            `"${existing.defaultImport}" vs "${incoming.defaultImport}"`,
        );
      }
      existing.defaultImport ||= incoming.defaultImport;

      // 3️⃣ 合并 namespace import
      if (
        existing.namespaceImport &&
        incoming.namespaceImport &&
        existing.namespaceImport !== incoming.namespaceImport
      ) {
        throw new Error(
          `Conflicting namespace imports from "${source}": ` +
            `"${existing.namespaceImport}" vs "${incoming.namespaceImport}"`,
        );
      }
      existing.namespaceImport ||= incoming.namespaceImport;
    }
  }

  return result;
}
